import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link'
import styled from 'styled-components'

import BuildPassLogo from '../../../public/buildpass.svg'
import { Text } from '../shared-components/BUI/Text'
import { LiveChat } from '../util-components/live-chat/LiveChat'

import { NarrowContent } from './CorePageViewEntity'

const Wrapper = styled(NarrowContent)`
  text-align: center;
  align-items: center;
  margin-top: 4rem;
`

type Props = {
  title: string
  subtitle?: React.ReactNode
  showLiveChat?: boolean
  anonymous?: boolean
  children?: React.ReactNode
}

export const ErrorLayout: React.FC<Props> = ({
  title,
  subtitle,
  showLiveChat = true,
  anonymous = true,
  children,
}) => {
  return (
    <Wrapper column gap="1rem">
      <Head>
        <title>{`BuildPass - ${title}`}</title>
        <meta property="og:title" content={title} key="title" />
      </Head>
      <Link href="https://www.buildpass.com.au">
        <Image src={BuildPassLogo} alt="BuildPass" />
      </Link>
      <Text variant="heading03" mt="1rem" mb="0.25rem">
        {title}
      </Text>
      {subtitle && (
        <Text variant="label01" secondary="_600">
          {subtitle}
        </Text>
      )}
      {children}
      {/* important that this is anonymous for public pages like PDF */}
      {showLiveChat && <LiveChat anonymous={anonymous} />}
    </Wrapper>
  )
}
